import { targetGroupALL } from '../constants';

// Helper function to compare two arrays (ignoring order)
export const arraysHaveSameElements = (arr1, arr2) => {
  if (!Array.isArray(arr1) || !Array.isArray(arr2)) return false;
  if (arr1.length !== arr2.length) return false;

  const sorted1 = [...arr1].sort();
  const sorted2 = [...arr2].sort();

  return sorted1.every(
    (val, index) => val.toLowerCase() === sorted2[index].toLowerCase(),
  );
};

// Filter the clm content by gender, countryCode, productTag and categories
export const filterClmContentPreview = (
  covers,
  countryCode,
  gender,
  productTag,
  previewProductTags,
  categories,
  previewCategories,
) => {
  const isProductTagFilterAllowed = previewProductTags.length !== 0;
  const isCategoriesFilterAllowed = previewCategories.length !== 0;
  const productTagFiltering = previewProductTags?.includes(productTag);
  const categoriesFiltering = arraysHaveSameElements(
    previewCategories,
    categories,
  );

  const passesProductTagFilter =
    !isProductTagFilterAllowed || productTagFiltering;
  const passesCategoriesFilter =
    !isCategoriesFilterAllowed || categoriesFiltering;

  if (passesProductTagFilter && passesCategoriesFilter) {
    return covers?.filter(
      preview =>
        preview.country_code?.toLowerCase() === countryCode?.toLowerCase() &&
        (preview.target_group?.toLowerCase() === gender?.toLowerCase() ||
          preview.target_group?.toLowerCase() === targetGroupALL.toLowerCase()),
    );
  }

  return [];
};

// Transforms the clmContentPreview into an array and filter out the images
// that have a gender, countryCode, categories and productTag different from the campaign line.
export const transformClmContentPreview = (
  clmContent,
  creatives,
  clCountryCode,
  clGender,
  clProductTag,
  clCategories,
) => {
  return Object.entries(clmContent || {})
    .map(([contentId, contentData]) => {
      // Find the matching  contentfulCreative for the clm content
      const matchingCreative =
        creatives?.find(creative => creative.contentId === contentId) || {};
      const contentfulProductTag = matchingCreative.productTags || [];
      const contentfulCategories = matchingCreative.categories || [];

      const coverImageData = filterClmContentPreview(
        contentData.cover_image_data,
        clCountryCode,
        clGender,
        clProductTag,
        contentfulProductTag,
        clCategories,
        contentfulCategories,
      );

      const coverVideoData = filterClmContentPreview(
        contentData.cover_video_data,
        clCountryCode,
        clGender,
        clProductTag,
        contentfulProductTag,
        clCategories,
        contentfulCategories,
      );

      return {
        contentId,
        coverImageData,
        coverVideoData,
        contentName: contentData.content_name,
      };
    })
    .filter(Boolean);
};

// This replaces invalid characters from a string
// to have a valid uniq key with it
export function sanitizeId(id) {
  return id.replace(/[^a-zA-Z0-9-_]/g, '_');
}
